/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./enabillLoadingPage.scss";

// i18n
import { useTranslation } from "react-i18next";

// redux
import { useSelector } from "react-redux";

// MUI
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

// assets
import BrwLogo from "../../layout-one/js/assets/images/icons/brw-icon.png";

// fb pixel
import { fbTrack } from "../../utils/fbPixel";

function BrwLoadingPage() {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);

  const [imgSrc, setImgSrc] = useState(null);
  const [imgLoaded, setImgLoaded] = useState(false);

  // 🔥 lazy-load image at runtime (REAL lazy loading)
  useEffect(() => {
    import(
      "../../layout-one/js/assets/images/loading-image/small-brw-app.jpeg"
    ).then((img) => {
      setImgSrc(img.default);
    });

    fbTrack("PageView");
    fbTrack("ViewContent", {
      content_name: "Home Page",
      content_category: "Landing",
    });
  }, []);

  return (
    <Dialog
      fullScreen
      open={true}
      className="classToTargetBrwLoadModal"
    >
      <DialogContent className="p-0">
        <div
          className={`promotionBannerParent d-flex flex-column justify-content-between align-items-center ${
            appState.langValue === "ar" ? "directionRtl" : ""
          }`}
        >
          {/* IMAGE AREA */}
          <div className="imageWrapper">
            {!imgLoaded && (
              <div className="imageSkeleton">
                <div className="dot-bricks"></div>
              </div>
            )}

            {imgSrc && (
              <img
                src={imgSrc}
                alt="BRW App"
                decoding="async"
                onLoad={() => setImgLoaded(true)}
                className={`promotionBannerImage ${
                  imgLoaded ? "show" : "hide"
                }`}
              />
            )}
          </div>

          {/* CONTENT */}
          <div className="loadingContent d-flex flex-column justify-content-between align-items-center">
            <p
              className="loadingText mb-2 familyPoppins"
              style={{ color: "#fff" }}
            >
              Pay securely with
            </p>

            <img
              src={BrwLogo}
              alt="BRW"
              width={50}
              height={50}
              loading="eager"
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default BrwLoadingPage;
